import { render } from "./OptionReplacePopUp.vue?vue&type=template&id=6d129abc"
import script from "./OptionReplacePopUp.vue?vue&type=script&lang=js"
export * from "./OptionReplacePopUp.vue?vue&type=script&lang=js"

import "./OptionReplacePopUp.vue?vue&type=style&index=0&id=6d129abc&lang=css"

import exportComponent from "/home/runner/work/nutristudents-k12-container/nutristudents-k12-container/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__